// Who a program is for, from the audience field (DetailsStep) to the terms the
// backend matches people on: everyone, or the roles and attribute values chosen,
// all lists together (AND), any or all of the values within each.

import type { RunAssessmentInput } from '../../../../../api/capability';
import type { FlowDetails } from './DetailsStep';

/** The key in `audienceMatch` for the Role line (the attribute lists use their own ids). */
export const ROLE_MATCH_KEY = 'role';

/** One of the organization's attribute lists (a team is a value of one), as the audience field shows it. */
export interface AudienceList {
  _id: string;
  name: string;
  values: Array<{ _id: string }>;
}

/** The audience chosen, as POST /v3/admin/capability/assessments takes it. */
export const audienceInput = (
  details: Pick<FlowDetails, 'allLearners' | 'roleIds' | 'audienceIds' | 'audienceMatch'>,
  lists: AudienceList[]
): RunAssessmentInput['audience'] => {
  if (details.allLearners) return { allLearners: true, roleIds: [], roleMatch: 'any', rules: [] };
  const chosen = new Set(details.audienceIds);
  return {
    allLearners: false,
    roleIds: details.roleIds,
    roleMatch: details.audienceMatch[ROLE_MATCH_KEY] ?? 'any',
    rules: lists
      .map((list) => ({
        listId: list._id,
        listName: list.name,
        matchType: details.audienceMatch[list._id] ?? 'any',
        valueIds: list.values.map((v) => String(v._id)).filter((id) => chosen.has(id))
      }))
      .filter((rule) => rule.valueIds.length > 0)
  };
};
